<template>
  <div>
    <apexchart
      type="bar"
      :options="chartOptions"
      :series="series"
      width="100%"
      height="500"
    />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts"
import Swal from "sweetalert2";
import AlertasDataService from "../../../services/AlertasDataService";
import Crypto from "../../../services/Crypto";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    datos: {
      type: Object,
      default: () => ({}),
    },
    total: {
      type: Number,
      default: 0,
    },
    enum: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      key: sessionStorage.getItem("key"),
      series: [],
      options: {
        responsive: true,
        maintainAspectRatio: false,
      },
      chartOptions: {
        chart: {
          id: "bar-chart",
          events: {
            dataPointSelection: (event, chartContext, config) => {
              if (config.dataPointIndex !== -1) {
                const { seriesIndex, dataPointIndex } = config;
                const category =
                  this.chartOptions.xaxis.categories[dataPointIndex];
                const value = this.series[seriesIndex].data[dataPointIndex];
                this.handleBarClick(category, value);
              }
            },
          },
        },
        title: {
          text: "",
          align: "center",
          class: "chart-title",
        },
        xaxis: {
          categories: [],
          title: {
            text: "",
          },
        },
        yaxis: {
          title: {
            text: "",
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 15,
            columnWidth: "50%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
          formatter: (val, opts) => {
            const dataValue =
              opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex];
            return dataValue === 0 ? "" : val;
          },
          style: {
            fontSize: "12px",
            colors: ["#000"],
          },
        },
      },
    };
  },
  watch: {
    datos: {
      immediate: true,
      handler(newDatos) {
        if (newDatos && Object.keys(newDatos).length > 0) {
          this.updateChart(newDatos);
        }
      },
    },
    enum: {
      immediate: true,
      handler(newDatos) {
        switch (newDatos) {
          case 1:
            this.chartOptions.title.text = `Alertas registradas en las últimas 24 hrs: ${this.total} `;
            this.chartOptions.xaxis.title.text = "Tipos de alertas";
            this.chartOptions.yaxis.title.text = "Número de alertas";
            break;
          case 2:
            this.chartOptions.title.text = `Alertas registradas en las últimas 24 hrs: ${this.total} `;
            this.chartOptions.xaxis.title.text = "Tipos de geocercas";
            this.chartOptions.yaxis.title.text = "Número de geocercas";
            break;
        }
      },
    },
  },
  methods: {
    updateChart(data) {
      const categories = Object.keys(data);
      const values = Object.values(data);

      // Configurar datos de la gráfica
      this.chartOptions.xaxis.categories = categories;
      this.series = [
        {
          name: "Total",
          data: values,
        },
      ];
    },
    async handleBarClick(category) {
      try {
        let response = null;

        if (this.enum === 1) {
          response = await AlertasDataService.getLatestAlertsByType(
            category,
            this.key
          );
        } else if (this.enum === 2) {
          response = await AlertasDataService.getLatestGeofencesByType(
            category,
            this.key
          );
        }
        const decoded = await Crypto.desencriptar(response.data, this.key);
        const countRegistros = decoded.length;

        Swal.fire({
          title: `Alertas de ${category}`,
          html: `
                        <div class="table-wrapper">
                            <table class="fl-table">
                                <thead>
                                    <tr>
                                        <th>Fecha</th>
                                        <th>Dispositivo</th>
                                        <th>Ubicación</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    ${decoded
                                      .map(
                                        (item) => `
                                    <tr>
                                        <td>${this.displayTime(
                                          item.fechaCreacion
                                        )}</td>
                                        <td>${item.dispositivo.nombre}</td>
                                        <td>
                                            <a href="${
                                              item.link
                                            }"target=_blank">
                                                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="25" height="25" viewBox="0 0 48 48">
                                                    <path fill="#1c9957" d="M42,39V9c0-1.657-1.343-3-3-3H9C7.343,6,6,7.343,6,9v30c0,1.657,1.343,3,3,3h30C40.657,42,42,40.657,42,39z"></path>
                                                    <path fill="#3e7bf1" d="M9,42h30c1.657,0-15-16-15-16S7.343,42,9,42z"></path>
                                                    <path fill="#cbccc9" d="M42,39V9c0-1.657-16,15-16,15S42,40.657,42,39z"></path>
                                                    <path fill="#efefef" d="M39,42c1.657,0,3-1.343,3-3v-0.245L26.245,23L23,26.245L38.755,42H39z"></path>
                                                    <path fill="#ffd73d" d="M42,9c0-1.657-1.343-3-3-3h-0.245L6,38.755V39c0,1.657,1.343,3,3,3h0.245L42,9.245V9z"></path>
                                                    <path fill="#d73f35" d="M36,2c-5.523,0-10,4.477-10,10c0,6.813,7.666,9.295,9.333,19.851C35.44,32.531,35.448,33,36,33s0.56-0.469,0.667-1.149C38.334,21.295,46,18.813,46,12C46,6.477,41.523,2,36,2z"></path>
                                                    <path fill="#752622" d="M36 8.5A3.5 3.5 0 1 0 36 15.5A3.5 3.5 0 1 0 36 8.5Z"></path>
                                                    <path fill="#fff" d="M14.493,12.531v2.101h2.994c-0.392,1.274-1.455,2.185-2.994,2.185c-1.833,0-3.318-1.485-3.318-3.318s1.486-3.318,3.318-3.318c0.824,0,1.576,0.302,2.156,0.799l1.548-1.547C17.22,8.543,15.92,8,14.493,8c-3.038,0-5.501,2.463-5.501,5.5s2.463,5.5,5.501,5.5c4.81,0,5.637-4.317,5.184-6.461L14.493,12.531z"></path>
                                                </svg>
                                            </a>
                                        </td>
                                    </tr>`
                                      )
                                      .join("")}
                                </tbody>
                            </table>
                        </div>
                        <div class="lblRegistros">Total de registros: ${countRegistros}</div>
                    `,
          width: 700,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Aceptar",
        });
      } catch (e) {
        console.error(e);
      }
    },
    displayTime(date) {
      let options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      };
      let fecha = new Date(date)
        .toLocaleDateString("es-ES", options)
        .toString();
      fecha = fecha[0].toUpperCase() + fecha.substring(1);
      return fecha;
    },
  },
};
</script>

<style>
.table-wrapper {
  max-height: 500px;
  overflow-y: auto;
  padding: 10px;
}

.fl-table {
  border-radius: 5px;
  font-size: 12px;
  font-weight: normal;
  border: none;
  border-collapse: collapse;
  width: 100%;
  max-width: 100%;
  white-space: nowrap;
  background-color: white;
}

.apexcharts-toolbar{
  top: -22px !important;
  right: 3px !important;
}

.fl-table td,
.fl-table th {
  text-align: center;
  padding: 8px;
}

.fl-table td {
  border-right: 1px solid #f8f8f8;
  font-size: 12px;
}

.fl-table thead th {
  color: #ffffff;
  background: #324960;
}

.fl-table tr:nth-child(even) {
  background: #f8f8f8;
}

.lblRegistros {
  font-size: 13px;
  text-align: right;
  margin-right: 20px;
}
</style>
